export * from './Icon'
export { default } from './Icon'
